const _excluded = ["agreementId", "serviceId", "serviceName", "isPaused", "onRefresh", "isDisabled", "tooltipTitle"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import { Switch, Spinner, Typography, ConfirmationModal, useGlobalContext } from 'seagull';
import { useStoreActions } from "../../../../../contexts";
import styles from "../BillingControl.module.scss";
import { timeModel } from "../../../../../models";

function PauseBillingConfirmationModal(props) {
  const {
    serviceName,
    dismissModal
  } = props;
  const title = 'Pause automatic billing';
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: title,
    "data-testid": "pause-confirmation-modal",
    textAlignCenter: false,
    width: "701",
    content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "You are about to pause automatic billing for", ' ', /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "pause-confirmation-modal-service-name",
      as: "span",
      weight: "bold"
    }, serviceName), "."), /*#__PURE__*/React.createElement(Typography, null, "The service will not be billed until you manually resume automatic billing for it."), /*#__PURE__*/React.createElement(Typography, {
      style: {
        marginTop: '1rem'
      }
    }, "Be sure to resume automatic billing several days before the billing date in order to avoid missing the next billing cycle.")),
    primaryButtonLabel: title,
    secondaryButtonLabel: "Cancel",
    onPrimaryButtonClick: () => dismissModal(true),
    onSecondaryButtonClick: () => dismissModal(false)
  });
}

function ResumeBillingConfirmationModal(props) {
  const {
    serviceName,
    nextBillingDate,
    dismissModal
  } = props;
  const title = 'Resume automatic billing';
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: title,
    "data-testid": "resume-confirmation-modal",
    textAlignCenter: false,
    width: "701",
    content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "You are about to activate automatic billing for", ' ', /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "resume-confirmation-modal-service-name",
      as: "span",
      weight: "bold"
    }, serviceName), "."), /*#__PURE__*/React.createElement(Typography, {
      style: {
        marginTop: '1rem'
      }
    }, "The upcoming invoice to include this service will be on", ' ', /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "resume-confirmation-modal-next-billing-date",
      as: "span",
      weight: "bold"
    }, timeModel.formatDate(nextBillingDate)), ".")),
    primaryButtonLabel: title,
    secondaryButtonLabel: "Cancel",
    onPrimaryButtonClick: () => dismissModal(true),
    onSecondaryButtonClick: () => dismissModal(false)
  });
}

export default function OngoingServiceSwitch(props) {
  const {
    agreementId,
    serviceId,
    serviceName,
    isPaused,
    onRefresh,
    isDisabled,
    tooltipTitle
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const [isResumed, setIsResumed] = useState(!isPaused);
  const [loading, setLoading] = useState(false);
  const globalContext = useGlobalContext();
  const {
    api
  } = useStoreActions();
  const testid = rest['data-testid'];

  async function onChange(e) {
    const {
      checked,
      value
    } = e.target;

    if (!checked
    /* pause service */
    ) {
      const confirmed = await globalContext.showModal({
        content: props => /*#__PURE__*/React.createElement(PauseBillingConfirmationModal, _extends({}, props, {
          serviceName: serviceName
        }))
      });
      if (!confirmed) return;
    } else {
      const nextBillingDate = await api.service.nextBillingDate(agreementId, serviceId);
      const confirmed = await globalContext.showModal({
        content: props => /*#__PURE__*/React.createElement(ResumeBillingConfirmationModal, _extends({}, props, {
          serviceName: serviceName,
          nextBillingDate: nextBillingDate
        }))
      });
      if (!confirmed) return;
    }

    try {
      setLoading(true);
      await api.service.togglePauseResumeBilling(agreementId, value, !checked);
      await onRefresh({
        silent: true
      });
      setIsResumed(checked);
    } catch (error) {
      globalContext.showErrorToast("Failed to ".concat(checked ? 'resume' : 'pause', " service"), 'pause-service-error-toast');
    } finally {
      setLoading(false);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.switch
  }, loading && /*#__PURE__*/React.createElement(Spinner, {
    size: 24
  }), /*#__PURE__*/React.createElement(Switch, _extends({
    disabled: loading || isDisabled,
    value: serviceId,
    checked: isResumed,
    tooltip: tooltipTitle ? {
      placement: 'top',
      title: /*#__PURE__*/React.createElement("div", {
        "data-testid": testid && "".concat(testid, "-tooltip")
      }, tooltipTitle)
    } : undefined,
    onChange: onChange
  }, rest)));
}